const styles = {
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      "& fieldset": {
        border: "none",
      },
    },
  },
  optionButton: {
    textTransform: "none",
    mt: 1,
    borderRadius: 4,
    color: "purple.main",
    borderColor: "purple.main",
  },
  submitButton: {
    color: "green.main",
    width: 30,
    height: 30,
    "&:hover": {
      color: "green.light",
    },
  },
};

export default styles;
